import { ComponentType } from "react";

export const withSwiftSupportedCharacters = <T,>(
    InputComponent: ComponentType<T>,
) => {
    const onInputSupportedCharacters = (
        e: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const supportedCharactersRegex = /[^a-zA-Z0-9/\-?:().,'+ ]/g;
        e.target.value = e.target.value.replace(supportedCharactersRegex, "");
    };

    return (props: T) => (
        <InputComponent {...props} onInput={onInputSupportedCharacters} />
    );
};
